//引入外部模組
// const InfiniteScroll = require('infinite-scroll/dist/infinite-scroll.pkgd'); //引入外部套件
// import imagesLoaded from "imagesloaded";

class Subscription{
  constructor(member_authCode) {
    //宣告共同參數
    this.member_authCode = member_authCode;
    // this.subScriptionForm = '#subScriptionForm';
    this.subScriptionForm = $('#subScriptionForm'); //新增&編輯的form名稱 object
  }
  //訂閱條件 - 新增
  addCondition() {
    $('#submitMapBtn').on('click', function() {
      let ajaxFile = 'ajax_subscription_onsale_process.php';

      let city_checked = $("input[name='city']").is(":checked");
      let area_checked = $("input[name='area']").not('#tbAreaAll').is(":checked");

      if(city_checked && area_checked) {
      
        $.post(ajaxFile, {
          dataType   : 'json',
          'subscription_type': 1,
          'member_authCode'  : $('#member_authCode').val(),
          'status'           : $('#status').val(),
          'formData'         : $('#subScriptionForm').serializeArray()
          
        }, (json) => {
          //處理訂閱完成後回來的程式
          if(json === 'ok') {

              Swal.fire({
                  title: '新增訂閱已完成',
                  confirmButtonText: '確定',
              }).then((result) => {
                  if (result.isConfirmed) {
                      history.go(-1);
                  }
              });

            // alert('新增訂閱已完成');
            // location.href = '?nav=subscription_onsale';
            // history.go(-1);
          }
        // }, 'json'); //$.pot(ajaxFile, {
        }); //$.post(ajaxFile, {  

      } else {
        Swal.fire({
          title: '請至少選一個縣市、區',
          icon: 'error',
        });
      }//if(city_checked && area_checked) {
        
      // location.href='?nav=subscription_onsale';
    });

  } //addCondition() {

  //訂閱條件 - 修改
  editCondition() {
    $('#submitMapBtn').on('click', function() {
      let ajaxFile = 'ajax_subscription_onsale_process.php';

      let city_checked = $("input[name='city']").is(":checked");
      let area_checked = $("input[name='area']").not('#tbAreaAll').is(":checked");

      if(city_checked && area_checked) {
      
        $.post(ajaxFile, {
          dataType   : 'json',
          'subscription_type': 1,
          'subscription_id'  : $('#subscription_id').val(),
          'member_authCode'  : $('#member_authCode').val(),
          'status'           : $('#status').val(),
          'formData'         : $('#subScriptionForm').serializeArray()
          
        }, (json) => {
          //處理訂閱完成後回來的程式
          console.log(json);
          if(json === 'ok') {

              Swal.fire({
                  title: '修改完成',
                  confirmButtonText: '確定',
              }).then((result) => {
                  if (result.isConfirmed) {
                      history.go(-1);
                  }
              });
            
            // alert('修改完成');
            
            // location.href = '?nav=subscription_onsale';
            // history.go(-1);
          }
        }); //$.post(ajaxFile, {  
      } else {
        Swal.fire({
          title: '請至少選一個縣市、區'
        });
      }//if(city_checked && area_checked) {    

      // console.log('修改');
    });
  } //editCondition(subscription_id) {

  delCondition() {
    $('.del_subsctiption').on('click', function() {
      Swal.fire({
        title: '確認是否刪除此訂閱條件?',
        showDenyButton: true,
        confirmButtonText: '是',
        denyButtonText: `否`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        /*
        if (result.isConfirmed) {
          Swal.fire('Saved!', '', 'success')
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', '', 'info')
        }
        */
        if (result.isConfirmed) {
            var ajaxFile = 'ajax_subscription_del.php';
            $.post(ajaxFile, {
                  dataType   : 'json',
                  member_authCode: $('#member_authCode').val(),
                  subscription_id: $(this).attr('data-info')
              
            }, (json) => {
              //處理訂閱完成後回來的程式
              if(json === 'ok') {
                // alert('已刪除');
                Swal.fire({
                    title: '已刪除',
                    confirmButtonText: '確定',
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload();
                    }
                });

                // Swal.fire('已刪除', '', 'success');

                // location.reload();
              }
            }); //$.post(ajaxFile, {  
        } //if (result.isConfirmed) {
       
      })
      /*
      if(confirm('確認是否刪除此訂閱條件?')) {
        var ajaxFile = 'ajax_subscription_del.php';
        $.post(ajaxFile, {
          dataType   : 'json',
          member_authCode: $('#member_authCode').val(),
          subscription_id: $(this).attr('data-info')
          
        }, (json) => {
          //處理訂閱完成後回來的程式
          if(json === 'ok') {
            alert('已刪除');
            location.reload();
          }
        }); //$.post(ajaxFile, {  
      } //if(confirm('確認是否刪除此訂閱條件?')) {
        */

    });
  } //delCondition($del_id) {

  //通知開啟或關閉
  noticeChange() {
    // console.log('改變通知狀態');
    $('.fa-bell').on('click', function() {

        var ajaxFile = 'ajax_subscription_onsale_notice.php';
        $.post(ajaxFile, {
          // dataType   : 'json',
          dataType   : 'html',
          member_authCode: $('#member_authCode').val(),
          subscription_id: $(this).attr('data-info')
          
        }, (json) => {
          //處理訂閱完成後回來的程式
          console.log(json);
          if(json === 'ok') {
            // alert('已更改');
            // location.reload();
            Swal.fire({
                title: '已更改',
                confirmButtonText: '確定',
            }).then((result) => {
                if (result.isConfirmed) {
                    location.reload();
                }
            });
          }

        }); //$.post(ajaxFile, {  

    });
  } //noticeChange($subscription_id) {

  //下拉到底拉新頁面進來
  jsonLoading() {

    // console.log(InfiniteScroll);
    // var infiniteScroll = new InfiniteScroll();
    
    // var $container = $('.tabBoxContent').infiniteScroll({
    //   append: false, // disable automatic appending
    // });
    
    
    //以下使用jquery的scroll，可用但較吃效能
    $(window).scroll(function() {
      var msg_list = $('.tabBoxContent');
      
      // if ($(document).scrollTop()<=0){
        // alert("滾動條已經到達頂部爲0");
      // }


      //原本使用
      if( ($(document).scrollTop()+1) >= $(document).height() - $(window).height()) {   

      // var isLoadingVisible = $('.loading').is(':visible');
      // console.log('sLoadingVisible的狀態');
      // console.log(isLoadingVisible);
      // var scrollDistanceFromBottom = $(document).height() - ($(window).scrollTop() + $(window).height());

      // if (!isLoadingVisible && scrollDistanceFromBottom <= 10) {

        
      // if($(window).scrollTop() + $(window).height() == $(document).height()) {
        // alert('123');
        //底部處理
        $('.loading').show(); //打開
        const subscription_id = $('#subscription_id').val(); //訂閱id
        const page_val =  parseInt($('#page').val()); //頁碼
        
        
        $.get('ajax_subscription_onsale_objs.php', {id: subscription_id, page: page_val}).done(function( data ){ 
            msg_list.append( data );
            $('#page').val(page_val+1); //頁碼+1
            $('.loading').hide(); //關閉
        });
        
      }

    });
    
    
  } //function jsonLoading() {

} //class Subscription{



//輸出
export {Subscription};


// WEBPACK FOOTER //
// ./js_new/subscription.js